import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { AuthenticationService } from '../authentication/authentication.service';
import { FleetDocumentRequestResult, FleetEmployee, FleetImportResponse, FleetVehicle, FleetVehicleDetail } from '../models/Fleet';

@Injectable({
    providedIn: 'root',
})
export class FleetService {
    httpOptions = {};

    constructor(private httpClient: HttpClient, private authenticationService: AuthenticationService) {
        this.httpOptions = authenticationService.getHeaders();
    }

    upload(file: File): Observable<FleetImportResponse> {
        const formData = new FormData();
        formData.append('file', file, file.name);

        const token = this.authenticationService.getToken();
        const uploadOptions = {
            headers: token ? new HttpHeaders({ Authorization: token }) : new HttpHeaders(),
        };

        return this.httpClient.post<FleetImportResponse>(`${environment.baseUrl}/fleet/upload`, formData, uploadOptions);
    }

    getVehicles(): Observable<FleetVehicle[]> {
        return this.httpClient.get<FleetVehicle[]>(`${environment.baseUrl}/fleet/vehicles`, this.httpOptions);
    }

    getVehicle(vehicleUuid: string): Observable<FleetVehicleDetail> {
        return this.httpClient.get<FleetVehicleDetail>(`${environment.baseUrl}/fleet/vehicles/${vehicleUuid}`, this.httpOptions);
    }

    getEmployeeFleet(employeeUuid: string): Observable<FleetEmployee> {
        return this.httpClient.get<FleetEmployee>(`${environment.baseUrl}/fleet/employee/${employeeUuid}`, this.httpOptions);
    }

    updateVehicle(vehicleUuid: string, payload: { notes?: string; registrationDocumentUrl?: string; assignedEmployeeUuid?: string }): Observable<FleetVehicleDetail> {
        return this.httpClient.put<FleetVehicleDetail>(`${environment.baseUrl}/fleet/vehicles/${vehicleUuid}`, payload, this.httpOptions);
    }

    /** Mails the vehicle's current driver a link to upload the missing documents. */
    requestDocuments(vehicleUuid: string): Observable<FleetDocumentRequestResult> {
        return this.httpClient.post<FleetDocumentRequestResult>(`${environment.baseUrl}/fleet/vehicles/${vehicleUuid}/document-request`, {}, this.httpOptions);
    }
}
